import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateFileAndInvalidateHistoryQueries } from "@/queries/refetch-files-and-history";
import { ProjectContext } from "@/stores/project-provider";

export const useRevertFileVersion = () => {
  const { id: projectId } = useContext(ProjectContext);
  const updateFileAndInvalidateHistoryQueries = useUpdateFileAndInvalidateHistoryQueries();

  return useMutationWithErrorHandler(async ({ id, srcRef }: { id: string; srcRef: string }) => {
    const file = await getRanaApiV1().FilesApi.projectFileCopy({
      sourcePath: id,
      destinationPath: id,
      projectId,
      srcRef,
    });
    updateFileAndInvalidateHistoryQueries({ beforeId: id, file });
  });
};
